import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { Play, ChevronRight, Plus, ArrowRight, Mail, ChevronLeft, Moon, X, BookOpen, PhoneCall,Video } from 'lucide-react';
import { Header } from '../layout/Header';
import { Card } from '../components/Card';
import { Button } from '../components/Button';
import { StatCard } from '../components/StatCard';
import { useAuth } from '../context/AuthContext';
import { NotificationBell } from '../items/NotificationBell';
import { RequestStoryModal } from '../items/RequestStoryModal';
import { ViewRecordedStoriesModal } from '../items/ViewRecordedStoriesModal';
import { AddStoriesModal } from '../items/AddKidStoriesModal';
import { useToast } from '../hooks/useToast';
import { BookViewerModal } from '../items/BookViewerModal';
import { PersonalBookModal } from '../items/PersonalBookModal';
import io from 'socket.io-client';
import API_URL from '../config/API_URL';
import { PremiumLibrarySection } from '../components/PremuimBookSection';
import { TokenPurchaseModal } from '../components/CheckoutForm';
import { LiveCallModal } from '../video_chat/LiveVideoCallModal';
import { VideoCallRoom } from '../video_chat/VideoCallRoomComponent';
import { IncomingCallNotification } from '../video_chat/IncomingCallNotification';

export const ParentDashboardPage = ({ userData }) => {
  const navigate = useNavigate();
  const { user, families } = useAuth();
  const { showToast, ToastContainer } = useToast();
  const avatarColors = ['#FF6B9D', '#4ECDC4', '#FFD93D', '#A8E6CF', '#FF8B94', '#C7CEEA'];

  const [bedtimeModeModal, setBedtimeModeModal] = useState(false);

  const [myRecordings, setMyRecordings] = useState([]);

  const [isPersonalBookModalOpen, setIsPersonalBookModalOpen] = useState(false);
  const [personalRecordings, setPersonalRecordings] = useState([]);
  const [loadingPersonalRecordings, setLoadingPersonalRecordings] = useState(true);

  const [showLiveCallModal, setShowLiveCallModal] = useState(false);
  const [activeVideoCall, setActiveVideoCall] = useState(null);
  const [incomingCall, setIncomingCall] = useState(null);

  const [sectionsExpanded, setSectionsExpanded] = useState({
    kids: false,
    readers: false,
    recentStories: false,
    bookLibrary: false,
    premiumLibrary: false
  });

  const [viewRecordingsModal, setViewRecordingsModal] = useState({
    isOpen: false,
    readerId: null,
    readerName: ''
  });
  
  const [requestStoryModal, setRequestStoryModal] = useState({
    isOpen: false,
    readerId: null,
    readerName: ''
  });
  
  const [addStoriesModal, setAddStoriesModal] = useState({
    isOpen: false,
    kidId: null,
    kidName: '',
    familyId: null
  });

  const [socket, setSocket] = useState(null);

  const [familyData, setFamilyData] = useState(null);
  const [children, setChildren] = useState([]);
  const [recentRecordings, setRecentRecordings] = useState([]);
  const [readers, setReaders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [books, setBooks] = useState([]);

  const [tokenPurchaseModal, setTokenPurchaseModal] = useState(false);

  const [singleStoryViewer, setSingleStoryViewer] = useState({
    isOpen: false,
    recording: null,
    viewerMode: 'both'
  });

  const videoRefSingle = useRef(null);
  const audioRefSingle = useRef(null);

  const [aiRecordings, setAiRecordings] = useState([]);
  const [subsectionsExpanded, setSubsectionsExpanded] = useState({
    readerStories: false,
    aiStories: false,
    myStories: false,
    personalStories: false  // Add this
  });

  // Add this fetch function after your existing fetchBooks function:
  const fetchAIRecordings = async (familyId) => {
    try {
      const response = await fetch(
        `${API_URL}/api/family/${familyId}/recent-ai-recordings`,
        { credentials: 'include' }
      );
      
      if (response.ok) {
        const data = await response.json();
        setAiRecordings(data);
      }
    } catch (error) {
      console.error('Error fetching AI recordings:', error);
    }
  };

  const [bookViewerModal, setBookViewerModal] = useState({
    isOpen: false,
    book: null,
    familyId: null
  });

  const [booksPagination, setBooksPagination] = useState({
    page: 1,
    per_page: 15,
    total_pages: 1,
    total_books: 0,
    has_next: false,
    has_prev: false
  });
  
  const handleOpenSingleStory = (recording) => {
    // Determine the appropriate viewer mode based on recording type
    let viewerMode = 'both'; // default
    
    if (recording.is_ai) {
      viewerMode = 'book'; // AI recordings only show book + audio player
    } else if (recording.video_url && !recording.audio_url) {
      viewerMode = 'video'; // Video-only recordings
    } else if (recording.audio_url && !recording.video_url) {
      viewerMode = 'book'; // Audio-only recordings show book + audio
    } else if (recording.video_url && recording.audio_url) {
      viewerMode = 'both'; // Has both video and audio (though rare)
    }
    
    setSingleStoryViewer({
      isOpen: true,
      recording: recording,
      viewerMode: viewerMode
    });
    console.log('[][][][][][][][][][][][][][][][')
    console.log('[][][][][][][][][][][][][][][][',recording)
    showToast(`Now playing: ${recording.book_title || 'Untitled Story'}`, 'info');
  };

  const closeSingleStoryViewer = () => {
    setSingleStoryViewer({
      isOpen: false,
      recording: null,
      viewerMode: 'both'
    });
    
    if (videoRefSingle.current) {
      videoRefSingle.current.pause();
    }
    if (audioRefSingle.current) {
      audioRefSingle.current.pause();
    }
  };

  const handleSingleStoryEnded = () => {
    // Just close the viewer when story ends
    showToast('Story finished!', 'success');
  };

  const [loadingBooks, setLoadingBooks] = useState(true);

  const toggleSection = (section) => {
    setSectionsExpanded(prev => ({ ...prev, [section]: !prev[section] }));
  };
  

  
  const handlePersonalBookRecord = (book) => {

    navigate(`/record-personal?bookId=${book.id}`);
  };

  useEffect(() => {
    if (!user?.id) return;

    console.log('🔌 Creating socket connection...');
    const newSocket = io(`${API_URL}`, {
      withCredentials: true,
      transports: ['websocket', 'polling']
    });

    newSocket.on('connect', () => {
      console.log('✅ Socket connected:', newSocket.id);
    });

    setSocket(newSocket);

    return () => {
      console.log('🧹 Disconnecting socket');
      newSocket.disconnect();
    };
  }, [user?.id]);

  useEffect(() => {
    if (!socket) return;

    socket.on('incoming-video-call', (data) => {
      console.log('📞 Incoming call from:', data);
      setIncomingCall({
        caller: data.caller,
        roomId: data.room_id,
        callId: data.call_id
      });
    });

    socket.on('call-accepted', (data) => {
      console.log('✅ Call accepted:', data);
      setActiveVideoCall({
        roomId: data.room_id,
        participants: data.participants
      });
      setShowLiveCallModal(false);
    });

    socket.on('call-declined', (data) => {
      console.log('❌ Call declined:', data);
      showToast(`${data.decliner_name} declined the call`, 'info');
    });

    socket.on('call-ended', (data) => {
      console.log('📵 Call ended:', data);
      setActiveVideoCall(null);
      showToast('Call ended', 'info');
    });

    return () => {
      socket.off('incoming-video-call');
      socket.off('call-accepted');
      socket.off('call-declined');
      socket.off('call-ended');
    };
  }, [socket]);

  useEffect(() => {
    const fetchFamilyData = async () => {
      try {
        const familiesResponse = await fetch(`${API_URL}/api/family/my-families`, {
          credentials: 'include'
        });
        
        if (!familiesResponse.ok) {
          throw new Error('Failed to fetch families');
        }
        
        const familiesData = await familiesResponse.json();
        
        if (familiesData.length === 0) {
          setLoading(false);
          showToast('No family found. Create one to get started!', 'info');
          return;
        }
        
        const familyId = familiesData[0].id;
        
        const detailResponse = await fetch(`${API_URL}/api/family/${familyId}`, {
          credentials: 'include'
        });
        
        if (!detailResponse.ok) {
          throw new Error('Failed to fetch family details');
        }
        
        const data = await detailResponse.json();
        setFamilyData(data);
        const avatarColors = ['#FF6B9D', '#4ECDC4', '#FFD93D', '#A8E6CF', '#FF8B94', '#C7CEEA'];

        const kidsData = (data.kids || []).map((kid, index) => ({
          id: kid.id,
          name: kid.first_name,
          avatar: kid.first_name.charAt(0), 
          avatarColor: avatarColors[index % avatarColors.length],
          stories: [],
          books: [],
          stats: { 
            storiesAvailable: 0,
            watchedThisWeek: 0,
            favorites: 0
          }
        }));
        
        const readerColors = ['#95E1D3', '#F38181', '#AA96DA', '#FCBAD3', '#FFFFD2'];

        const readerMembers = (data.members || []).filter(m => m.family_role === 'reader');
        
        const readersDataPromises = readerMembers.map(async (reader, index) => {
          try {
            const statsResponse = await fetch(
              `${API_URL}/api/family/${familyId}/reader/${reader.id}/stats`,
              { credentials: 'include' }
            );
            
            let stats = {
              storiesRecorded: 0,
              lastRecorded: 'Never',
              readsTo: []
            };
            
            if (statsResponse.ok) {
              stats = await statsResponse.json();
            }
            
            return {
              id: reader.id,
              name: `${reader.first_name} ${reader.last_name}`,
              avatar: reader.first_name.charAt(0),
              avatarColor: readerColors[index % readerColors.length],
              relationship: 'Reader',
              storiesRecorded: stats.stories_recorded,
              lastRecorded: stats.last_recorded,
              readsTo: stats.reads_to
            };
          } catch (error) {
            console.error(`Error fetching stats for reader ${reader.id}:`, error);
            return {
              id: reader.id,
              name: `${reader.first_name} ${reader.last_name}`,
              avatar: reader.first_name.charAt(0),
              avatarColor: readerColors[index % readerColors.length],
              relationship: 'Reader',
              storiesRecorded: 0,
              lastRecorded: 'Unknown',
              readsTo: data.kids ? data.kids.map(k => k.first_name) : []
            };
          }
        });
        
        const readersData = await Promise.all(readersDataPromises);
        setReaders(readersData);

        try {
          const recordingsResponse = await fetch(
            `${API_URL}/api/family/${familyId}/recent-recordings`,
            { credentials: 'include' }
          );
          
          if (recordingsResponse.ok) {
            const recordingsData = await recordingsResponse.json();
            console.log(recordingsData);
            setRecentRecordings(recordingsData);
            
            // Fetch AI recordings
            const aiResponse = await fetch(
              `${API_URL}/api/family/${familyId}/recent-ai-recordings`,
              { credentials: 'include' }
            );
            
            let aiRecordingsData = [];
            if (aiResponse.ok) {
              aiRecordingsData = await aiResponse.json();
              setAiRecordings(aiRecordingsData);
            }

            // ⭐ FETCH MY (PARENT) RECORDINGS - ADD THIS HERE ⭐
            const myRecordingsResponse = await fetch(
              `${API_URL}/api/family/${familyId}/my-recordings`,
              { credentials: 'include' }
            );
            
            if (myRecordingsResponse.ok) {
              const myRecordingsData = await myRecordingsResponse.json();
              setMyRecordings(myRecordingsData);
            }
            // ⭐ END OF NEW FETCH ⭐
            
            // Combine both regular and AI recordings
            const allRecordings = [...recordingsData, ...aiRecordingsData];
            
            // Group recordings by kid name
            const storiesByKidName = {};
            allRecordings.forEach(recording => {
              const kidName = recording.kid_name?.toLowerCase();
              if (kidName) {
                if (!storiesByKidName[kidName]) {
                  storiesByKidName[kidName] = [];
                }
                storiesByKidName[kidName].push(recording);
              }
            });
            
            // Update children with their stories
            const kidsWithStories = kidsData.map(kid => {
              const kidStories = storiesByKidName[kid.name.toLowerCase()] || [];
              return {
                ...kid,
                stories: kidStories,
                stats: {
                  ...kid.stats,
                  storiesAvailable: kidStories.length
                }
              };
            });
            
            setChildren(kidsWithStories);
            const personalRecordingsResponse = await fetch(
              `${API_URL}/api/personal-books/my-recordings`,
              { credentials: 'include' }
            );

            if (personalRecordingsResponse.ok) {
              const personalRecordingsData = await personalRecordingsResponse.json();
              setPersonalRecordings(personalRecordingsData);
            }
            setLoadingPersonalRecordings(false);
          }
        } catch (error) {
          console.error('Error fetching recent recordings:', error);
          showToast('Could not load recent recordings', 'warning');
        }
        
      } catch (error) {
        console.error('Error fetching family data:', error);
        showToast('Failed to load family data', 'error');
      } finally {
        setLoading(false);
      }
    };

    fetchFamilyData();
  }, []);

  const handleAcceptCall = async (roomId) => {
    try {
      const response = await fetch(`${API_URL}/api/video-call/accept`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({
          room_id: roomId,
          user_id: user.id
        })
      });

      const data = await response.json();
      if (data.success) {
        setActiveVideoCall({
          roomId: roomId,
          participants: data.participants
        });
        setIncomingCall(null);
      }
    } catch (error) {
      console.error('Failed to accept call:', error);
      showToast('Failed to join call', 'error');
    }
  };

  const handleDeclineCall = async (roomId) => {
    try {
      await fetch(`${API_URL}/api/video-call/decline`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({
          room_id: roomId,
          user_id: user.id
        })
      });

      setIncomingCall(null);
    } catch (error) {
      console.error('Failed to decline call:', error);
    }
  };

  const handleLeaveCall = () => {
    setActiveVideoCall(null);
  };

  const toggleSubsection = (subsection) => {
    setSubsectionsExpanded(prev => ({ ...prev, [subsection]: !prev[subsection] }));
  };

  const fetchBooks = async (page = 1, perPage = 15) => {
    setLoadingBooks(true);
    try {
      const response = await fetch(
        `${API_URL}/api/books?page=${page}&per_page=${perPage}`
      );
      const data = await response.json();
      setBooks(data.books);
      setBooksPagination(data.pagination);
    } catch (error) {
      console.error('Error fetching books:', error);
      showToast('Failed to load book library', 'error');
    } finally {
      setLoadingBooks(false);
    }
  };

  useEffect(() => {
    fetchBooks();
  }, []);

  const handlePageChange = (newPage) => {
    fetchBooks(newPage, booksPagination.per_page);
  };

  const handlePerPageChange = (newPerPage) => {
    fetchBooks(1, newPerPage); // Reset to page 1 when changing items per page
  };





  const allStories = children.flatMap(child => child.stories);
  const lastWatchedStory = allStories
    .filter(story => story.watched)
    .sort((a, b) => b.id - a.id)[0];

  const aggregateStats = {
    storiesAvailable: children.reduce((sum, child) => sum + child.stats.storiesAvailable, 0),
    watchedThisWeek: children.reduce((sum, child) => sum + child.stats.watchedThisWeek, 0),
    favorites: children.reduce((sum, child) => sum + child.stats.favorites, 0),
    familyFriends: readers.length,
    todaysStorytime: "32m"
  };

  const handleViewRecordings = (readerId, readerName) => {
    setViewRecordingsModal({
      isOpen: true,
      readerId,
      readerName
    });
    showToast(`Viewing stories from ${readerName}`, 'info');
  };

  const handleRequestStory = (readerId, readerName) => {
    setRequestStoryModal({
      isOpen: true,
      readerId,
      readerName
    });
  };

  const handleAddStories = (kidId, kidName, familyId) => {
    setAddStoriesModal({
      isOpen: true,
      kidId,
      kidName,
      familyId
    });
  };

  const handleSelectKidForBedtime = (kidId) => {
    setBedtimeModeModal(false);
    navigate(`/child/${kidId}`, { state: { bedtimeMode: true } });
    showToast('Starting bedtime stories...', 'info');
  };

  if (loading) {
    return (
      <div style={{ minHeight: '100vh', background: 'linear-gradient(135deg, #fce7f3 0%, #dbeafe 100%)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <p style={{ fontSize: '1.25rem', color: '#6b7280' }}>Loading your family dashboard...</p>
      </div>
    );
  }

  if (!familyData) {
    return (
      <div style={{ minHeight: '100vh', background: 'linear-gradient(135deg, #fce7f3 0%, #dbeafe 100%)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '2rem' }}>
        <Card style={{ padding: '2rem', textAlign: 'center', maxWidth: '500px' }}>
          <h2 style={{ fontSize: '1.5rem', fontWeight: 'bold', marginBottom: '1rem', color: '#1f2937' }}>
            Welcome to Story Time!
          </h2>
          <p style={{ color: '#6b7280', marginBottom: '1.5rem' }}>
            It looks like you haven't created a family yet. Let's get started!
          </p>
          <Button onClick={() => navigate('/family')} style={{ width: '100%' }}>
            Create Your Family
          </Button>
        </Card>
      </div>
    );
  }

  return (
    <div style={{ minHeight: '100vh', background: 'linear-gradient(135deg, #fce7f3 0%, #dbeafe 100%)' }}>
      <ToastContainer />
      <Header userName={`${user.first_name} ${user.last_name}`} userType="parent" />
      <div style={{ maxWidth: '1280px', margin: '0 auto', padding: '2rem 1.5rem' }}>
        {/* Hero Section */}
        <Card style={{ background: 'linear-gradient(90deg, #db2777 0%, #be185d 100%)', color: 'white', marginBottom: '2rem', padding: '2rem', position: 'relative' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: '1rem' }}>
            <div>
              <h2 style={{ fontSize: '1.875rem', fontWeight: 'bold', marginBottom: '0.75rem' }}>Family Story Time</h2>
              <p style={{ color: '#fce7f3', fontSize: '1.125rem', marginBottom: '1.5rem' }}>
                {allStories.filter(s => !s.watched).length} new stories from grandparents are waiting!
              </p>
              <div style={{ display: 'flex', gap: '0.75rem', flexWrap: 'wrap' }}>
                <Button 
                  onClick={() => setBedtimeModeModal(true)}
                  style={{ 
                    background: '#1e1b4b', 
                    color: 'white',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.5rem'
                  }}
                >
                  <Moon size={16} /> Bedtime Mode
                </Button>
                <Button onClick={() => navigate('/family')} variant="reader" style={{ background: '#2bbe18ff', color: 'white' }}>
                  View Readers/Family
                </Button>
                {families && families[0] && (
                  <NotificationBell 
                    userId={user.id} 
                    familyId={families[0].id}
                  />
                )}
                {/* <Button 
                  onClick={() => setIsPersonalBookModalOpen(true)}
                  variant="reader"
                  style={{
                    marginTop: '.5rem',
                    background: '#33bd8fff',
                    color: 'white',
                    fontWeight: '600'
                  }}
                >
                  <BookOpen style={{ width: '1.25rem', height: '1.25rem' }} />
                  Record Story you Own
                </Button> */}
              </div>
              <Button 
                onClick={() => setIsPersonalBookModalOpen(true)}
                variant="secondary1"
                style={{
                  marginTop: '.5rem',
                  background: '#33bd8fff',
                  color: 'white',
                  fontWeight: '600'
                }}
              >
                <BookOpen style={{ width: '1.25rem', height: '1.25rem' }} />
                Record Story you Own
              </Button>
              <Button 
                onClick={() => setShowLiveCallModal(true)}  // CHANGED THIS LINE
                variant="secondary2"
                style={{
                  marginTop: '.5rem',
                  background: '#33bd8fff',
                  color: 'white',
                  marginLeft: '0.5rem',
                  fontWeight: '600'
                }}
              >
                <PhoneCall style={{ width: '1.25rem', height: '1.25rem' }} />
                Live Call
              </Button>
            </div>
            {lastWatchedStory && (
              <div
                style={{
                  background: 'linear-gradient(135deg, #ffffff 0%, #f8f0f5 100%)',
                  borderRadius: '1rem',
                  padding: '1.25rem',
                  maxWidth: '300px',
                  width: '100%',
                  boxShadow: '0 6px 12px rgba(0, 0, 0, 0.15), 0 3px 6px rgba(0, 0, 0, 0.1)',
                  transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                  cursor: 'pointer',
                  border: '1px solid #fce7f3'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'scale(1.03)';
                  e.currentTarget.style.boxShadow = '0 8px 16px rgba(0, 0, 0, 0.2), 0 4px 8px rgba(0, 0, 0, 0.15)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'scale(1)';
                  e.currentTarget.style.boxShadow = '0 6px 12px rgba(0, 0, 0, 0.15), 0 3px 6px rgba(0, 0, 0, 0.1)';
                }}
                onClick={() => navigate(`/story/${lastWatchedStory.id}`)}
              >
                <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', marginBottom: '0.75rem' }}>
                  <div style={{
                    fontSize: '3rem',
                    background: '#db2777',
                    borderRadius: '0.5rem',
                    width: '60px',
                    height: '60px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: 'white',
                    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)'
                  }}>
                    {lastWatchedStory.thumbnail}
                  </div>
                  <div>
                    <p style={{ fontWeight: '700', fontSize: '1rem', color: '#1f2937', lineHeight: '1.2' }}>
                      {lastWatchedStory.title}
                    </p>
                    <p style={{ fontSize: '0.875rem', color: '#6b7280' }}>
                      by {lastWatchedStory.narrator}
                    </p>
                  </div>
                </div>
                <p style={{ fontSize: '0.75rem', color: '#4b5563', marginBottom: '0.75rem' }}>
                  Last read story
                </p>
                <Button
                  variant="primary"
                  style={{
                    width: '100%',
                    background: '#db2777',
                    color: 'white',
                    fontSize: '0.875rem',
                    padding: '0.5rem',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '0.5rem'
                  }}
                >
                  Replay Story <Play size={14} />
                </Button>
              </div>
            )}
          </div>
        </Card>

        {/* Stats Section */}
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))', gap: '1rem', marginBottom: '2rem' }}>
          <StatCard value={aggregateStats.storiesAvailable} label="Recordings Available" color="#db2777" />
          <StatCard value={aggregateStats.watchedThisWeek} label="Watched This Week" color="#9333ea" />
          {/* <StatCard value={aggregateStats.favorites} label="Favorites" color="#2563eb" /> */}
          <div onClick={() => navigate('/family')} style={{ cursor: 'pointer' }}>
            <StatCard value={aggregateStats.familyFriends} label="Family & Friends" color="#059669" />
          </div>
          {/* <StatCard value={aggregateStats.todaysStorytime} label="Today's Storytime" color="#059669" /> */}
        </div>

        {/* Kids Section */}
        <Card style={{ padding: '1.5rem', marginBottom: '2rem' }}>
          <div 
            style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', cursor: 'pointer', marginBottom: sectionsExpanded.kids ? '1.5rem' : '0' }}
            onClick={() => toggleSection('kids')}
          >
            <h3 style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#1f2937' }}>Kids</h3>
            <ChevronRight size={24} style={{ transform: sectionsExpanded.kids ? 'rotate(90deg)' : 'rotate(0deg)', transition: 'transform 0.2s' }} />
          </div>

          {sectionsExpanded.kids && (
            <>
              {children.length === 0 ? (
                <div style={{ textAlign: 'center', padding: '2rem' }}>
                  <p style={{ color: '#6b7280', marginBottom: '1rem' }}>No kids added yet</p>
                  <Button onClick={() => navigate('/family')}>
                    <Plus size={20} /> Add Your First Kid
                  </Button>
                </div>
              ) : (
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))', gap: '1.5rem' }}>
                  {children.map(child => (
                    <div
                      key={child.id}
                      style={{
                        border: '1px solid #e5e7eb',
                        borderRadius: '0.75rem',
                        padding: '1.25rem',
                        background: 'white',
                        boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)',
                        transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                        cursor: 'pointer'
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = 'scale(1.02)';
                        e.currentTarget.style.boxShadow = '0 6px 12px rgba(0, 0, 0, 0.15)';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = 'scale(1)';
                        e.currentTarget.style.boxShadow = '0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)';
                      }}
                    >
                      <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '1rem' }}>
                        <div style={{
                          fontSize: '2rem',
                          fontWeight: 'bold',
                          background: `linear-gradient(135deg, ${child.avatarColor}, ${child.avatarColor}dd)`,
                          borderRadius: '50%',
                          width: '60px',
                          height: '60px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          color: 'white',
                          boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                          textTransform: 'uppercase',
                          border: '3px solid white'
                        }}>
                          {child.avatar}
                        </div>
                        <div>
                          <h4 style={{ fontWeight: '700', color: '#1f2937', fontSize: '1.25rem' }}>{child.name}</h4>
                          <p style={{ fontSize: '0.875rem', color: '#6b7280' }}>
                            {child.stories.length} stories
                          </p>
                        </div>
                      </div>
                      <div
                        style={{
                          display: 'grid',
                          gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
                          gap: '0.75rem',
                        }}
                      >
                        <Button
                          onClick={() => navigate(`/child/${child.id}`)}
                          variant="primary"
                          style={{
                            width: '100%',
                            background: '#db2777',
                            color: 'white',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: '0.5rem',
                            padding: '0.625rem 0.75rem',
                            minHeight: 44,
                          }}
                        >
                          View Stories <ArrowRight size={16} />
                        </Button>

                        <Button
                          onClick={() => handleAddStories(child.id, child.name, familyData.id)}
                          variant="secondary"
                          style={{
                            width: '100%',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: '0.5rem',
                            padding: '0.625rem 0.75rem',
                            minHeight: 44,
                          }}
                        >
                          Add Stories <Plus size={16} />
                        </Button>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </>
          )}
        </Card>

        {/* Grandparents & Readers Section */}
        <Card style={{ padding: '1.5rem', marginBottom: '2rem' }}>
          <div 
            style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', cursor: 'pointer', marginBottom: sectionsExpanded.readers ? '1.5rem' : '0' }}
            onClick={() => toggleSection('readers')}
          >
            <h3 style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#1f2937' }}>Grandparents & Caregiver</h3>
            <ChevronRight size={24} style={{ transform: sectionsExpanded.readers ? 'rotate(90deg)' : 'rotate(0deg)', transition: 'transform 0.2s' }} />
          </div>

          {sectionsExpanded.readers && (
            <>
              {readers.length === 0 ? (
                <div style={{ textAlign: 'center', padding: '2rem' }}>
                  <p style={{ color: '#6b7280', marginBottom: '1rem' }}>No readers yet. Share your family code!</p>
                  <Button onClick={() => navigate('/family')}>
                    View Family Code
                  </Button>
                </div>
              ) : (
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: '1.5rem' }}>
                  {readers.map(reader => (
                    <div
                      key={reader.id}
                      style={{
                        border: '1px solid #e5e7eb',
                        borderRadius: '0.75rem',
                        padding: '1.25rem',
                        background: 'white',
                        boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)',
                        transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                        cursor: 'pointer'
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = 'scale(1.02)';
                        e.currentTarget.style.boxShadow = '0 6px 12px rgba(0, 0, 0, 0.15)';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = 'scale(1)';
                        e.currentTarget.style.boxShadow = '0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)';
                      }}
                    >
                      <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '1rem' }}>
                        <div style={{
                          fontSize: '2rem',
                          fontWeight: 'bold',
                          background: `linear-gradient(135deg, ${reader.avatarColor}, ${reader.avatarColor}dd)`,
                          borderRadius: '50%',
                          width: '60px',
                          height: '60px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          color: 'white',
                          boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                          textTransform: 'uppercase',
                          border: '3px solid white'
                        }}>
                          {reader.avatar}
                        </div>
                        <div>
                          <h4 style={{ fontWeight: '700', color: '#1f2937', fontSize: '1.25rem' }}>{reader.name}</h4>
                          <p style={{ fontSize: '0.875rem', color: '#6b7280' }}>
                            {reader.relationship}
                          </p>
                        </div>
                      </div>
                      <div style={{ marginBottom: '1rem' }}>
                        <p style={{ fontSize: '0.875rem', color: '#4b5563', marginBottom: '0.25rem' }}>
                          <strong>{reader.storiesRecorded}</strong> stories recorded
                        </p>
                        <p style={{ fontSize: '0.875rem', color: '#6b7280', marginBottom: '0.25rem' }}>
                          Last recorded: {reader.lastRecorded}
                        </p>
                        <p style={{ fontSize: '0.875rem', color: '#6b7280' }}>
                          Reads to: {reader.readsTo.join(', ')}
                        </p>
                      </div>
                      <div style={{ display: 'flex', gap: '0.5rem' }}>
                        <Button
                          onClick={() => handleViewRecordings(reader.id, reader.name)}
                          variant="primary"
                          style={{
                            flex: 1,
                            background: '#059669',
                            color: 'white',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: '0.5rem',
                            padding: '0.625rem',
                            fontSize: '0.875rem'
                          }}
                        >
                          View Stories <ArrowRight size={16} />
                        </Button>
                        <Button
                          onClick={() => handleRequestStory(reader.id, reader.name)}
                          variant="secondary"
                          style={{
                            flex: 1,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: '0.5rem',
                            padding: '0.625rem',
                            fontSize: '0.875rem'
                          }}
                        >
                          Request Story <Mail size={16} />
                        </Button>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </>
          )}
        </Card>

        {/* Recent Stories Section */}
        <Card style={{ padding: '1.5rem', marginBottom: '2rem' }}>
        <div 
          style={{ 
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'space-between', 
            cursor: 'pointer', 
            marginBottom: sectionsExpanded.recentStories ? '1.5rem' : '0' 
          }}
          onClick={() => toggleSection('recentStories')}
        >
          <h3 style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#1f2937' }}>Recent Stories</h3>
          <ChevronRight 
            size={24} 
            style={{ 
              transform: sectionsExpanded.recentStories ? 'rotate(90deg)' : 'rotate(0deg)', 
              transition: 'transform 0.2s' 
            }} 
          />
        </div>

        {sectionsExpanded.recentStories && (
          <>
            {/* Grandparent/Reader Stories Subsection */}
            <div style={{ 
              marginBottom: '1.5rem', 
              border: '1px solid #e5e7eb', 
              borderRadius: '0.5rem',
              overflow: 'hidden'
            }}>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  padding: '1rem 1.25rem',
                  background: 'linear-gradient(135deg, #db2777 0%, #be185d 100%)',
                  cursor: 'pointer'
                }}
                onClick={() => toggleSubsection('readerStories')}
              >
                <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
                  <div style={{
                    width: '32px',
                    height: '32px',
                    borderRadius: '50%',
                    background: 'rgba(255, 255, 255, 0.2)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '1.25rem'
                  }}>
                    📖
                  </div>
                  <h4 style={{ 
                    fontSize: '1.125rem', 
                    fontWeight: '600', 
                    color: 'white',
                    margin: 0
                  }}>
                    Grandparent & Reader Stories
                  </h4>
                  <span style={{
                    background: 'rgba(255, 255, 255, 0.2)',
                    color: 'white',
                    padding: '0.25rem 0.75rem',
                    borderRadius: '1rem',
                    fontSize: '0.875rem',
                    fontWeight: '600'
                  }}>
                    {recentRecordings.length}
                  </span>
                </div>
                <ChevronRight 
                  size={20} 
                  style={{ 
                    transform: subsectionsExpanded.readerStories ? 'rotate(90deg)' : 'rotate(0deg)', 
                    transition: 'transform 0.2s',
                    color: 'white'
                  }} 
                />
              </div>

              {subsectionsExpanded.readerStories && (
                <div style={{ padding: '1.25rem' }}>
                  {recentRecordings.length === 0 ? (
                    <p style={{ color: '#6b7280', textAlign: 'center', padding: '2rem' }}>
                      No reader recordings yet
                    </p>
                  ) : (
                    <div style={{ 
                      display: 'grid', 
                      gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))', 
                      gap: '1.5rem' 
                    }}>
                      {recentRecordings.map(recording => (
                        <div
                          key={recording.id}
                          style={{
                            border: '1px solid #e5e7eb',
                            borderRadius: '0.75rem',
                            padding: '1.25rem',
                            background: 'white',
                            boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1)',
                            transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                            cursor: 'pointer'
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.transform = 'scale(1.02)';
                            e.currentTarget.style.boxShadow = '0 6px 12px rgba(0, 0, 0, 0.15)';
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.transform = 'scale(1)';
                            e.currentTarget.style.boxShadow = '0 4px 6px -1px rgb(0 0 0 / 0.1)';
                          }}
                          onClick={() => handleOpenSingleStory(recording)}

                        >
                          <div style={{ display: 'flex', alignItems: 'flex-start', gap: '0.75rem', marginBottom: '1rem' }}>
                            <div style={{
                              fontSize: '1.5rem',
                              fontWeight: 'bold',
                              background: 'linear-gradient(135deg, #db2777, #be185d)',
                              borderRadius: '50%',
                              width: '48px',
                              height: '48px',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              color: 'white',
                              boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                              textTransform: 'uppercase',
                              flexShrink: 0
                            }}>
                              {recording.reader_avatar}
                            </div>
                            <div style={{ flex: 1, minWidth: 0 }}>
                              <h4 style={{ 
                                fontWeight: '700', 
                                color: '#1f2937', 
                                fontSize: '1rem',
                                marginBottom: '0.25rem',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap'
                              }}>
                                {recording.book_title || recording.title || 'Untitled Story'}
                              </h4>
                              <p style={{ fontSize: '0.875rem', color: '#6b7280', marginBottom: '0.25rem' }}>
                                by {recording.reader_name}
                              </p>
                              {recording.kid_name && (
                                <p style={{ fontSize: '0.75rem', color: '#9ca3af' }}>
                                  For {recording.kid_name}
                                </p>
                              )}
                            </div>
                          </div>
                          
                          {recording.book_author && (
                            <p style={{ 
                              fontSize: '0.75rem', 
                              color: '#6b7280', 
                              marginBottom: '0.75rem',
                              fontStyle: 'italic'
                            }}>
                              Book by {recording.book_author}
                            </p>
                          )}
                          
                          <div style={{ 
                            display: 'flex', 
                            justifyContent: 'space-between', 
                            alignItems: 'center',
                            paddingTop: '0.75rem',
                            borderTop: '1px solid #e5e7eb'
                          }}>
                            <span style={{ fontSize: '0.75rem', color: '#9ca3af' }}>
                              {new Date(recording.created_at).toLocaleDateString()}
                            </span>
                            {recording.video_url && (
                              <Button
                                variant="primary"
                                style={{
                                  background: '#db2777',
                                  color: 'white',
                                  padding: '0.375rem 0.75rem',
                                  fontSize: '0.75rem',
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: '0.375rem'
                                }}
                              >
                                <Play size={14} /> Watch
                              </Button>
                            )}
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              )}
            </div>
            <div style={{ 
              marginBottom: '1.5rem', 
              border: '1px solid #e5e7eb', 
              borderRadius: '0.5rem',
              overflow: 'hidden'
            }}>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  padding: '1rem 1.25rem',
                  background: 'linear-gradient(135deg, #2bbe18ff 0%, #35ff1aff 100%)',
                  cursor: 'pointer'
                }}
                onClick={() => toggleSubsection('myStories')}
              >
                <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
                  <div style={{
                    width: '32px',
                    height: '32px',
                    borderRadius: '50%',
                    background: 'rgba(255, 255, 255, 0.2)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '1.25rem'
                  }}>
                    📖
                  </div>
                  <h4 style={{ 
                    fontSize: '1.125rem', 
                    fontWeight: '600', 
                    color: 'white',
                    margin: 0
                  }}>
                    Your Recordings
                  </h4>
                  <span style={{
                    background: 'rgba(255, 255, 255, 0.2)',
                    color: 'white',
                    padding: '0.25rem 0.75rem',
                    borderRadius: '1rem',
                    fontSize: '0.875rem',
                    fontWeight: '600'
                  }}>
                    {myRecordings.length}
                  </span>
                </div>
                <ChevronRight 
                  size={20} 
                  style={{ 
                    transform: subsectionsExpanded.readerStories ? 'rotate(90deg)' : 'rotate(0deg)', 
                    transition: 'transform 0.2s',
                    color: 'white'
                  }} 
                />
              </div>
                  {subsectionsExpanded.myStories && (
                    <div style={{ padding: '1.25rem' }}>
                      {myRecordings.length === 0 ? (
                        <p style={{ color: '#6b7280', textAlign: 'center', padding: '2rem' }}>
                          You haven't recorded any stories yet. Go to a book and record one!
                        </p>
                      ) : (
                        <div style={{ 
                          display: 'grid', 
                          gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))', 
                          gap: '1.5rem' 
                        }}>
                          {myRecordings.map(recording => (
                            <div
                              key={recording.id}
                              style={{
                                border: '1px solid #e5e7eb',
                                borderRadius: '0.75rem',
                                padding: '1.25rem',
                                background: 'linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%)',
                                boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1)',
                                transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                                cursor: 'pointer'
                              }}
                              onMouseEnter={(e) => {
                                e.currentTarget.style.transform = 'scale(1.02)';
                                e.currentTarget.style.boxShadow = '0 6px 12px rgba(43, 190, 24, 0.2)';
                              }}
                              onMouseLeave={(e) => {
                                e.currentTarget.style.transform = 'scale(1)';
                                e.currentTarget.style.boxShadow = '0 4px 6px -1px rgb(0 0 0 / 0.1)';
                              }}
                              onClick={() => handleOpenSingleStory(recording)}
                            >
                              <div style={{ display: 'flex', alignItems: 'flex-start', gap: '0.75rem', marginBottom: '1rem' }}>
                                <div style={{
                                  width: '120px',
                                  height: '160px',
                                  borderRadius: '0.5rem',
                                  overflow: 'hidden',
                                  backgroundColor: '#f9fafb',
                                  border: '2px solid #2bbe18ff',
                                  boxShadow: '0 2px 4px rgba(43, 190, 24, 0.3)',
                                  flexShrink: 0
                                }}>
                                  {recording.book?.pdf_url ? (
                                    <iframe 
                                      src={`${recording.book.pdf_url.trim()}#page=1&view=FitH`}
                                      style={{ 
                                        width: '100%', 
                                        height: '100%', 
                                        border: 'none',
                                        pointerEvents: 'none'
                                      }}
                                      title={`${recording.book_title} preview`}
                                    />
                                  ) : (
                                    <div style={{
                                      width: '100%',
                                      height: '100%',
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'center',
                                      fontSize: '2.5rem',
                                      background: 'linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%)'
                                    }}>
                                      📖
                                    </div>
                                  )}
                                </div>
                                <div style={{ flex: 1, minWidth: 0 }}>
                                  {recording.book_author && (
                                    <p style={{ 
                                      fontSize: '0.75rem', 
                                      color: '#6b7280', 
                                      marginBottom: '0.75rem',
                                      fontStyle: 'italic'
                                    }}>
                                      Book by {recording.book_author}
                                    </p>
                                  )}
                                  {recording.kid_name && (
                                    <p style={{ fontSize: '0.75rem', color: '#6b7280' }}>
                                      For {recording.kid_name}
                                    </p>
                                  )}
                                </div>
                              </div>
                              
                              <h4 style={{ 
                                fontWeight: '700', 
                                color: '#1f2937', 
                                fontSize: '1rem',
                                marginBottom: '0.25rem',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap'
                              }}>
                                {recording.book_title || recording.title || 'Untitled Story'}
                              </h4>
                              
                              <div style={{ 
                                display: 'flex', 
                                justifyContent: 'space-between', 
                                alignItems: 'center',
                                paddingTop: '0.75rem',
                                borderTop: '1px solid #d1d5db'
                              }}>
                                <span style={{ fontSize: '0.75rem', color: '#9ca3af' }}>
                                  {new Date(recording.created_at).toLocaleDateString()}
                                </span>
                                {recording.video_url && (
                                  <Button
                                    variant="primary"
                                    style={{
                                      background: 'linear-gradient(135deg, #2bbe18ff, #35ff1aff)',
                                      color: 'white',
                                      padding: '0.375rem 0.75rem',
                                      fontSize: '0.75rem',
                                      display: 'flex',
                                      alignItems: 'center',
                                      gap: '0.375rem'
                                    }}
                                  >
                                    <Play size={14} /> Watch
                                  </Button>
                                )}
                              </div>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  )}
              
            </div>
            <div style={{ 
                marginBottom: '1.5rem', 
                border: '1px solid #e5e7eb', 
                borderRadius: '0.5rem',
                overflow: 'hidden'
              }}>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    padding: '1rem 1.25rem',
                    background: 'linear-gradient(135deg, #268d9bff 0%, #40c3ffff 100%)',
                    cursor: 'pointer'
                  }}
                  onClick={() => toggleSubsection('personalStories')}
                >
                  <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
                    <div style={{
                      width: '32px',
                      height: '32px',
                      borderRadius: '50%',
                      background: 'rgba(255, 255, 255, 0.2)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontSize: '1.25rem'
                    }}>
                      📚
                    </div>
                    <h4 style={{ 
                      fontSize: '1.125rem', 
                      fontWeight: '600', 
                      color: 'white',
                      margin: 0
                    }}>
                      Your Personal Book Recordings
                    </h4>
                    <span style={{
                      background: 'rgba(255, 255, 255, 0.2)',
                      color: 'white',
                      padding: '0.25rem 0.75rem',
                      borderRadius: '1rem',
                      fontSize: '0.875rem',
                      fontWeight: '600'
                    }}>
                      {personalRecordings.length}
                    </span>
                  </div>
                  <ChevronRight 
                    size={20} 
                    style={{ 
                      transform: subsectionsExpanded.personalStories ? 'rotate(90deg)' : 'rotate(0deg)', 
                      transition: 'transform 0.2s',
                      color: 'white'
                    }} 
                  />
                </div>
                
                {subsectionsExpanded.personalStories && (
                  <div style={{ padding: '1.25rem' }}>
                    {loadingPersonalRecordings ? (
                      <p style={{ color: '#6b7280', textAlign: 'center', padding: '2rem' }}>
                        Loading personal recordings...
                      </p>
                    ) : personalRecordings.length === 0 ? (
                      <p style={{ color: '#6b7280', textAlign: 'center', padding: '2rem' }}>
                        You haven't recorded any personal books yet. Click "Record Story you Own" to start!
                      </p>
                    ) : (
                      <div style={{ 
                        display: 'grid', 
                        gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))', 
                        gap: '1.5rem' 
                      }}>
                        {personalRecordings.map(recording => (
                          <div
                            key={`personal-${recording.id}`}
                            style={{
                              border: '2px solid #10b981',
                              borderRadius: '0.75rem',
                              padding: '1.25rem',
                              background: 'linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%)',
                              boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1)',
                              transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                              cursor: 'pointer',
                              position: 'relative'
                            }}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.transform = 'scale(1.02)';
                              e.currentTarget.style.boxShadow = '0 6px 12px rgba(16, 185, 129, 0.2)';
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.transform = 'scale(1)';
                              e.currentTarget.style.boxShadow = '0 4px 6px -1px rgb(0 0 0 / 0.1)';
                            }}
                            onClick={() => navigate(`/personal-recording/${recording.id}`)}
                          >
                            {/* Personal Book Badge */}
                            <div style={{
                              position: 'absolute',
                              top: '0.75rem',
                              right: '0.75rem',
                              background: 'linear-gradient(135deg, #10b981, #059669)',
                              color: 'white',
                              padding: '0.25rem 0.5rem',
                              borderRadius: '0.25rem',
                              fontSize: '0.625rem',
                              fontWeight: '700',
                              display: 'flex',
                              alignItems: 'center',
                              gap: '0.25rem'
                            }}>
                              <BookOpen size={12} />
                              PERSONAL
                            </div>

                            <div style={{ display: 'flex', alignItems: 'flex-start', gap: '0.75rem', marginBottom: '1rem' }}>
                              {recording.book?.cover_image_url ? (
                                <div style={{
                                  width: '80px',
                                  height: '110px',
                                  borderRadius: '0.5rem',
                                  overflow: 'hidden',
                                  border: '2px solid #10b981',
                                  boxShadow: '0 2px 4px rgba(16, 185, 129, 0.3)',
                                  flexShrink: 0
                                }}>
                                  <img 
                                    src={recording.book.cover_image_url}
                                    alt={recording.book?.title}
                                    style={{
                                      width: '100%',
                                      height: '100%',
                                      objectFit: 'cover'
                                    }}
                                  />
                                </div>
                              ) : (
                                <div style={{
                                  width: '80px',
                                  height: '110px',
                                  borderRadius: '0.5rem',
                                  background: 'linear-gradient(135deg, #10b981, #059669)',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  fontSize: '2rem',
                                  color: 'white',
                                  border: '2px solid #10b981',
                                  flexShrink: 0
                                }}>
                                  📚
                                </div>
                              )}
                              
                              <div style={{ flex: 1, minWidth: 0 }}>
                                <h4 style={{ 
                                  fontWeight: '700', 
                                  color: '#064e3b', 
                                  fontSize: '1rem',
                                  marginBottom: '0.25rem',
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis',
                                  whiteSpace: 'nowrap'
                                }}>
                                  {recording.book?.title || 'Untitled Book'}
                                </h4>
                                <p style={{ 
                                  fontSize: '0.75rem', 
                                  color: '#047857', 
                                  marginBottom: '0.5rem'
                                }}>
                                  by {recording.book?.author || 'Unknown'}
                                </p>
                                <p style={{ 
                                  fontSize: '0.75rem', 
                                  color: '#065f46',
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: '0.25rem'
                                }}>
                                  {recording.recording_type === 'audio_only' ? '🎙️' : '📹'}
                                  {recording.recording_type === 'audio_only' ? 'Audio' : 'Video'}
                                </p>
                                {recording.kids && recording.kids.length > 0 && (
                                  <p style={{ 
                                    fontSize: '0.75rem', 
                                    color: '#065f46',
                                    marginTop: '0.25rem'
                                  }}>
                                    For: {recording.kids.map(k => k.name).join(', ')}
                                  </p>
                                )}
                              </div>
                            </div>
                            
                            <div style={{ 
                              display: 'flex', 
                              justifyContent: 'space-between', 
                              alignItems: 'center',
                              paddingTop: '0.75rem',
                              borderTop: '1px solid #10b981'
                            }}>
                              <span style={{ fontSize: '0.75rem', color: '#065f46' }}>
                                {new Date(recording.created_at).toLocaleDateString()}
                              </span>
                              <Button
                                variant="primary"
                                style={{
                                  background: 'linear-gradient(135deg, #10b981, #059669)',
                                  color: 'white',
                                  padding: '0.375rem 0.75rem',
                                  fontSize: '0.75rem',
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: '0.375rem'
                                }}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  navigate(`/personal-recording/${recording.id}`);
                                }}
                              >
                                <Play size={14} /> View
                              </Button>
                            </div>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                )}
              </div>

            {/* AI Stories Subsection */}
            <div style={{ 
              border: '1px solid #e5e7eb', 
              borderRadius: '0.5rem',
              overflow: 'hidden'
            }}>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  padding: '1rem 1.25rem',
                  background: 'linear-gradient(135deg, #8b5cf6 0%, #6d28d9 100%)',
                  cursor: 'pointer'
                }}
                onClick={() => toggleSubsection('aiStories')}
              >
                <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
                  <div style={{
                    width: '32px',
                    height: '32px',
                    borderRadius: '50%',
                    background: 'rgba(255, 255, 255, 0.2)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '1.25rem'
                  }}>
                    🤖
                  </div>
                  <h4 style={{ 
                    fontSize: '1.125rem', 
                    fontWeight: '600', 
                    color: 'white',
                    margin: 0
                  }}>
                    AI Voice-Cloned Stories
                  </h4>
                  <span style={{
                    background: 'rgba(255, 255, 255, 0.2)',
                    color: 'white',
                    padding: '0.25rem 0.75rem',
                    borderRadius: '1rem',
                    fontSize: '0.875rem',
                    fontWeight: '600'
                  }}>
                    {aiRecordings.length}
                  </span>
                </div>
                <ChevronRight 
                  size={20} 
                  style={{ 
                    transform: subsectionsExpanded.aiStories ? 'rotate(90deg)' : 'rotate(0deg)', 
                    transition: 'transform 0.2s',
                    color: 'white'
                  }} 
                />
              </div>

              {subsectionsExpanded.aiStories && (
                <div style={{ padding: '1.25rem' }}>
                  {aiRecordings.length === 0 ? (
                    <p style={{ color: '#6b7280', textAlign: 'center', padding: '2rem' }}>
                      No AI-generated stories yet
                    </p>
                  ) : (
                    <div style={{ 
                      display: 'grid', 
                      gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))', 
                      gap: '1.5rem' 
                    }}>
                      {aiRecordings.map((recording, index) => (
                        <div
                          key={`ai-${recording.id}-${index}`}
                          style={{
                            border: '1px solid #e5e7eb',
                            borderRadius: '0.75rem',
                            padding: '1.25rem',
                            background: 'linear-gradient(135deg, #faf5ff 0%, #f3e8ff 100%)',
                            boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1)',
                            transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                            cursor: 'pointer',
                            position: 'relative'
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.transform = 'scale(1.02)';
                            e.currentTarget.style.boxShadow = '0 6px 12px rgba(139, 92, 246, 0.2)';
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.transform = 'scale(1)';
                            e.currentTarget.style.boxShadow = '0 4px 6px -1px rgb(0 0 0 / 0.1)';
                          }}
                          onClick={() => handleOpenSingleStory(recording)}

                        >
                          <div style={{
                            position: 'absolute',
                            top: '0.75rem',
                            right: '0.75rem',
                            background: 'linear-gradient(135deg, #8b5cf6, #6d28d9)',
                            color: 'white',
                            padding: '0.25rem 0.5rem',
                            borderRadius: '0.25rem',
                            fontSize: '0.625rem',
                            fontWeight: '700',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '0.25rem'
                          }}>
                            <span>🤖</span> AI VOICE
                          </div>

                          <div style={{ display: 'flex', alignItems: 'flex-start', gap: '0.75rem', marginBottom: '1rem' }}>
                            <div style={{
                              fontSize: '1.5rem',
                              fontWeight: 'bold',
                              background: 'linear-gradient(135deg, #8b5cf6, #6d28d9)',
                              borderRadius: '50%',
                              width: '48px',
                              height: '48px',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              color: 'white',
                              boxShadow: '0 2px 4px rgba(139, 92, 246, 0.3)',
                              textTransform: 'uppercase',
                              flexShrink: 0
                            }}>
                              {recording.reader_avatar}
                            </div>
                            <div style={{ flex: 1, minWidth: 0 }}>
                              <h4 style={{ 
                                fontWeight: '700', 
                                color: '#1f2937', 
                                fontSize: '1rem',
                                marginBottom: '0.25rem',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap'
                              }}>
                                {recording.book_title || 'Untitled Story'}
                              </h4>
                              <p style={{ fontSize: '0.875rem', color: '#6b7280', marginBottom: '0.25rem' }}>
                                AI Voice: {recording.voice_name}
                              </p>
                              <p style={{ fontSize: '0.75rem', color: '#8b5cf6', fontWeight: '600' }}>
                                Original: {recording.reader_name}
                              </p>
                              {recording.kid_name && (
                                <p style={{ fontSize: '0.75rem', color: '#9ca3af' }}>
                                  For {recording.kid_name}
                                </p>
                              )}
                            </div>
                          </div>
                          
                          {recording.book_author && (
                            <p style={{ 
                              fontSize: '0.75rem', 
                              color: '#6b7280', 
                              marginBottom: '0.75rem',
                              fontStyle: 'italic'
                            }}>
                              Book by {recording.book_author}
                            </p>
                          )}
                          
                          {recording.play_count > 0 && (
                            <p style={{
                              fontSize: '0.75rem',
                              color: '#8b5cf6',
                              marginBottom: '0.75rem',
                              fontWeight: '500'
                            }}>
                              Played {recording.play_count} {recording.play_count === 1 ? 'time' : 'times'}
                            </p>
                          )}
                          
                          <div style={{ 
                            display: 'flex', 
                            justifyContent: 'space-between', 
                            alignItems: 'center',
                            paddingTop: '0.75rem',
                            borderTop: '1px solid #e5e7eb'
                          }}>
                            <span style={{ fontSize: '0.75rem', color: '#9ca3af' }}>
                              {new Date(recording.created_at).toLocaleDateString()}
                            </span>
                            {recording.audio_url && (
                              <Button
                                variant="primary"
                                style={{
                                  background: 'linear-gradient(135deg, #8b5cf6, #6d28d9)',
                                  color: 'white',
                                  padding: '0.375rem 0.75rem',
                                  fontSize: '0.75rem',
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: '0.375rem'
                                }}
                              >
                                <Play size={14} /> Listen
                              </Button>
                            )}
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              )}
            </div>
          </>
        )}
      </Card>

        {/* Book Library Section */}
        <Card style={{ padding: '1.5rem' }}>
          <div 
            style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', cursor: 'pointer', marginBottom: sectionsExpanded.bookLibrary ? '1.5rem' : '0' }}
            onClick={() => toggleSection('bookLibrary')}
          >
            <h3 style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#1f2937' }}>Book Library</h3>
            <ChevronRight size={24} style={{ transform: sectionsExpanded.bookLibrary ? 'rotate(90deg)' : 'rotate(0deg)', transition: 'transform 0.2s' }} />
          </div>

          {sectionsExpanded.bookLibrary && (
            <>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.5rem', flexWrap: 'wrap', gap: '1rem' }}>
                <p style={{ color: '#4b5563', margin: 0 }}>
                  Choose a book to record or send a request to a family member.
                </p>
                
                {/* Items per page selector */}
                <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                  <span style={{ fontSize: '0.875rem', color: '#6b7280' }}>Show:</span>
                  <select
                    value={booksPagination.per_page}
                    onChange={(e) => handlePerPageChange(Number(e.target.value))}
                    style={{
                      padding: '0.375rem 0.75rem',
                      borderRadius: '0.375rem',
                      border: '1px solid #d1d5db',
                      fontSize: '0.875rem',
                      cursor: 'pointer'
                    }}
                  >
                    <option value={15}>15</option>
                    <option value={25}>25</option>
                    <option value={50}>50</option>
                  </select>
                  <span style={{ fontSize: '0.875rem', color: '#6b7280' }}>per page</span>
                </div>
              </div>
              {loadingBooks ? (
                <p style={{ color: '#6b7280', textAlign: 'center' }}>Loading books...</p>
              ) : books.length === 0 ? (
                <p style={{ color: '#6b7280', textAlign: 'center' }}>No books available yet.</p>
              ) : (
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: '1.5rem' }}>
                  {books.map(book => (
                    <div
                      key={book.id}
                      style={{
                        border: '1px solid #e5e7eb',
                        borderRadius: '0.75rem',
                        padding: '1.25rem',
                        textAlign: 'center',
                        background: 'white',
                        boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'space-between',
                        gap: '1rem'
                      }}
                    >
                      <div>
                        {book.pdf_url ? (
                          <div style={{ 
                            width: '100%', 
                            height: '250px', 
                            marginBottom: '0.75rem',
                            border: '1px solid #e5e7eb',
                            borderRadius: '0.5rem',
                            overflow: 'hidden',
                            backgroundColor: '#f9fafb'
                          }}>
                            <iframe 
                              src={`${book.pdf_url.trim()}#page=1&view=FitH`}
                              style={{ 
                                width: '100%', 
                                height: '100%', 
                                border: 'none',
                                pointerEvents: 'none'
                              }}
                              title={`${book.title} preview`}
                            />
                          </div>
                        ) : (
                          <div style={{ fontSize: '3.5rem', marginBottom: '0.75rem' }}>📖</div>
                        )}
                        <h4 style={{ fontWeight: '600', color: '#1f2937', fontSize: '1.125rem' }}>{book.title}</h4>
                        <p style={{ fontSize: '0.875rem', color: '#6b7280', marginTop: '0.25rem' }}>by {book.author}</p>
                        {book.description && (
                          <p style={{ fontSize: '0.75rem', color: '#9ca3af', marginTop: '0.5rem' }}>{book.description}</p>
                        )}
                      </div>
                      <Button 
                        variant="primary" 
                        style={{ width: '100%' }}
                        onClick={() => {
                           setBookViewerModal({
                             isOpen: true,
                             book: book,
                             familyId: familyData.id
                           });
                         }}
                      >
                        View Story <ArrowRight size={16} style={{ marginLeft: '0.5rem' }} />
                      </Button>
                    </div>
                  ))}
                </div>
                
              )}
              <div style={{ 
  display: 'flex', 
  justifyContent: 'space-between', 
  alignItems: 'center',
  paddingTop: '1.5rem',
  borderTop: '1px solid #e5e7eb',
  flexWrap: 'wrap',
  gap: '1rem'
}}>
  {/* Page info */}
  <div style={{ fontSize: '0.875rem', color: '#6b7280' }}>
    Showing {((booksPagination.page - 1) * booksPagination.per_page) + 1} to{' '}
    {Math.min(booksPagination.page * booksPagination.per_page, booksPagination.total_books)} of{' '}
    {booksPagination.total_books} books
  </div>

  {/* Pagination buttons */}
  <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'center' }}>
    <button
      onClick={() => handlePageChange(booksPagination.page - 1)}
      disabled={!booksPagination.has_prev}
      style={{
        padding: '0.5rem 0.75rem',
        borderRadius: '0.375rem',
        border: '1px solid #d1d5db',
        background: booksPagination.has_prev ? 'white' : '#f3f4f6',
        color: booksPagination.has_prev ? '#374151' : '#9ca3af',
        cursor: booksPagination.has_prev ? 'pointer' : 'not-allowed',
        display: 'flex',
        alignItems: 'center',
        gap: '0.25rem',
        fontSize: '0.875rem'
      }}
    >
      <ChevronLeft size={16} /> Previous
    </button>

    {/* Page numbers */}
    <div style={{ display: 'flex', gap: '0.25rem' }}>
      {Array.from({ length: booksPagination.total_pages }, (_, i) => i + 1)
        .filter(pageNum => {
          // Show first page, last page, current page, and pages around current
          return pageNum === 1 || 
                 pageNum === booksPagination.total_pages ||
                 Math.abs(pageNum - booksPagination.page) <= 1;
        })
        .map((pageNum, index, array) => {
          // Add ellipsis if there's a gap
          const showEllipsis = index > 0 && pageNum - array[index - 1] > 1;
          
          return (
            <React.Fragment key={pageNum}>
              {showEllipsis && (
                <span style={{ padding: '0.5rem', color: '#9ca3af' }}>...</span>
              )}
              <button
                onClick={() => handlePageChange(pageNum)}
                style={{
                  padding: '0.5rem 0.75rem',
                  borderRadius: '0.375rem',
                  border: '1px solid #d1d5db',
                  background: pageNum === booksPagination.page ? '#db2777' : 'white',
                  color: pageNum === booksPagination.page ? 'white' : '#374151',
                  cursor: 'pointer',
                  fontSize: '0.875rem',
                  fontWeight: pageNum === booksPagination.page ? 'bold' : 'normal',
                  minWidth: '2.5rem'
                }}
              >
                {pageNum}
              </button>
            </React.Fragment>
          );
        })}
    </div>

    <button
      onClick={() => handlePageChange(booksPagination.page + 1)}
      disabled={!booksPagination.has_next}
      style={{
        padding: '0.5rem 0.75rem',
        borderRadius: '0.375rem',
        border: '1px solid #d1d5db',
        background: booksPagination.has_next ? 'white' : '#f3f4f6',
        color: booksPagination.has_next ? '#374151' : '#9ca3af',
        cursor: booksPagination.has_next ? 'pointer' : 'not-allowed',
        display: 'flex',
        alignItems: 'center',
        gap: '0.25rem',
        fontSize: '0.875rem'
      }}
    >
      Next <ChevronRight size={16} />
    </button>
  </div>
</div>
            </>
          )}
        </Card>
        <PremiumLibrarySection
          isExpanded={sectionsExpanded.premiumLibrary}
          onToggle={() => toggleSection('premiumLibrary')}
          familyData={familyData}
          showToast={showToast}
          navigate={navigate}
          onOpenBookViewer={(book) => {
            setBookViewerModal({
              isOpen: true,
              book: book,
              familyId: familyData.id
            });
          }}
          onOpenTokenPurchase={() => setTokenPurchaseModal(true)}

        />
      </div>
      {bedtimeModeModal && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'rgba(0, 0, 0, 0.7)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 1000,
          padding: '1rem'
        }}>
          <Card style={{
            maxWidth: '600px',
            width: '100%',
            maxHeight: '80vh',
            overflow: 'auto',
            padding: '2rem',
            background: 'linear-gradient(135deg, #1e1b4b 0%, #312e81 100%)',
            border: '2px solid #4c1d95'
          }}>
            <div style={{ 
              display: 'flex', 
              justifyContent: 'space-between', 
              alignItems: 'center', 
              marginBottom: '1.5rem' 
            }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
                <div style={{
                  background: 'linear-gradient(135deg, #fbbf24, #f59e0b)',
                  borderRadius: '50%',
                  width: '40px',
                  height: '40px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  boxShadow: '0 0 20px rgba(251, 191, 36, 0.5)'
                }}>
                  <Moon size={24} color="white" />
                </div>
                <h2 style={{ 
                  fontSize: '1.75rem', 
                  fontWeight: 'bold', 
                  color: 'white',
                  textShadow: '0 2px 4px rgba(0,0,0,0.3)'
                }}>
                  Bedtime Mode
                </h2>
              </div>
              <Button
                onClick={() => setBedtimeModeModal(false)}
                variant="ghost"
                style={{ 
                  fontSize: '1.5rem', 
                  color: 'white',
                  background: 'rgba(255, 255, 255, 0.1)',
                  borderRadius: '50%',
                  width: '40px',
                  height: '40px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
              >
                <X size={24} />
              </Button>
            </div>

            <p style={{ 
              color: '#e0e7ff', 
              marginBottom: '2rem',
              fontSize: '1.125rem',
              textAlign: 'center'
            }}>
              Select which child to play stories for tonight 🌙
            </p>

            {children.length === 0 ? (
              <p style={{ 
                color: '#c7d2fe', 
                textAlign: 'center', 
                padding: '2rem' 
              }}>
                No children added yet
              </p>
            ) : (
              <div style={{ 
                display: 'grid', 
                gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', 
                gap: '1.5rem' 
              }}>
                {children.map((child, index) => (
                  <div
                    key={child.id}
                    onClick={() => handleSelectKidForBedtime(child.id)}
                    style={{
                      background: 'linear-gradient(135deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0.05) 100%)',
                      backdropFilter: 'blur(10px)',
                      border: '2px solid rgba(255, 255, 255, 0.2)',
                      borderRadius: '1rem',
                      padding: '1.5rem',
                      textAlign: 'center',
                      cursor: 'pointer',
                      transition: 'all 0.3s ease',
                      boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = 'scale(1.05) translateY(-5px)';
                      e.currentTarget.style.boxShadow = '0 12px 24px rgba(251, 191, 36, 0.3)';
                      e.currentTarget.style.borderColor = '#fbbf24';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = 'scale(1)';
                      e.currentTarget.style.boxShadow = '0 4px 6px rgba(0, 0, 0, 0.1)';
                      e.currentTarget.style.borderColor = 'rgba(255, 255, 255, 0.2)';
                    }}
                  >
                    <div style={{
                      fontSize: '3rem',
                      fontWeight: 'bold',
                      background: `linear-gradient(135deg, ${avatarColors[index % avatarColors.length]}, ${avatarColors[index % avatarColors.length]}dd)`,
                      borderRadius: '50%',
                      width: '80px',
                      height: '80px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      color: 'white',
                      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2)',
                      textTransform: 'uppercase',
                      border: '4px solid white',
                      margin: '0 auto 1rem'
                    }}>
                      {child.avatar}
                    </div>
                    <h3 style={{ 
                      fontWeight: '700', 
                      color: 'white', 
                      fontSize: '1.25rem',
                      marginBottom: '0.5rem',
                      textShadow: '0 2px 4px rgba(0,0,0,0.3)'
                    }}>
                      {child.name}
                    </h3>
                    <p style={{ 
                      fontSize: '0.875rem', 
                      color: '#c7d2fe',
                      marginBottom: '1rem'
                    }}>
                      {child.stories.length} stories ready
                    </p>
                    <div style={{
                      background: 'linear-gradient(135deg, #fbbf24, #f59e0b)',
                      color: 'white',
                      padding: '0.5rem 1rem',
                      borderRadius: '0.5rem',
                      fontSize: '0.875rem',
                      fontWeight: '600',
                      display: 'inline-flex',
                      alignItems: 'center',
                      gap: '0.5rem',
                      boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
                    }}>
                      <Moon size={14} /> Start Stories
                    </div>
                  </div>
                ))}
              </div>
            )}
          </Card>
        </div>
      )}

      {/* Modals */}
      <ViewRecordedStoriesModal
        isOpen={viewRecordingsModal.isOpen}
        onClose={() => setViewRecordingsModal({ isOpen: false, readerId: null, readerName: '' })}
        readerId={viewRecordingsModal.readerId}
        readerName={viewRecordingsModal.readerName}
      />

      <RequestStoryModal
        isOpen={requestStoryModal.isOpen}
        onClose={() => setRequestStoryModal({ isOpen: false, readerId: null, readerName: '' })}
        readerId={requestStoryModal.readerId}
        readerName={requestStoryModal.readerName}
        kids={children}
        user={user}
      />

      <AddStoriesModal
        isOpen={addStoriesModal.isOpen}
        onClose={() => setAddStoriesModal({ isOpen: false, kidId: null, kidName: '', familyId: null })}
        kidId={addStoriesModal.kidId}
        kidName={addStoriesModal.kidName}
        familyId={addStoriesModal.familyId}
        currentUserId={user.id}
      />

       <BookViewerModal
         isOpen={bookViewerModal.isOpen}
         onClose={() => setBookViewerModal({ isOpen: false, book: null, familyId: null })}
         book={bookViewerModal.book}
         familyId={bookViewerModal.familyId}
         allRecordings={recentRecordings}
         familyReaders={readers}  // ADD THIS
          kids={children} 
       />
       <TokenPurchaseModal
          isOpen={tokenPurchaseModal}
          onClose={() => setTokenPurchaseModal(false)}
          showToast={showToast}
          onPurchaseComplete={() => {
            // Refresh premium status after purchase
            // fetchPremiumStatus();
          }}
        />
        {singleStoryViewer.isOpen && singleStoryViewer.recording && (
          console.log(singleStoryViewer),
          <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'rgba(0, 0, 0, 0.95)',
            display: 'flex',
            flexDirection: 'column',
            zIndex: 1000
          }}>
            {/* Header */}
            <div style={{
              background: singleStoryViewer.recording.is_ai 
                ? 'linear-gradient(135deg, #8b5cf6, #6d28d9)' 
                : 'rgba(0, 0, 0, 0.8)',
              padding: '1rem 2rem',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              borderBottom: '1px solid rgba(255, 255, 255, 0.1)'
            }}>
              <div>
                <h2 style={{ fontSize: '1.5rem', fontWeight: 'bold', color: 'white', marginBottom: '0.25rem' }}>
                  {singleStoryViewer.recording.book_title || 'Untitled Story'}
                </h2>
                <p style={{ fontSize: '0.875rem', color: '#e5e7eb' }}>
                  {singleStoryViewer.recording.is_ai 
                    ? `AI Voice: ${singleStoryViewer.recording.voice_name} (Original: ${singleStoryViewer.recording.reader_name})`
                    : `Read by ${singleStoryViewer.recording.reader_name}`
                  }
                </p>
              </div>
              <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'center' }}>
                {/* View mode buttons - only show for video recordings */}
                {!singleStoryViewer.recording.is_ai && singleStoryViewer.recording.video_url && (
                  <>
                    <Button
                      onClick={() => setSingleStoryViewer(prev => ({ ...prev, viewerMode: 'video' }))}
                      variant={singleStoryViewer.viewerMode === 'video' ? 'primary' : 'ghost'}
                      style={{
                        background: singleStoryViewer.viewerMode === 'video' ? '#db2777' : 'transparent',
                        color: 'white',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '0.5rem',
                        padding: '0.5rem 1rem'
                      }}
                    >
                      <Video size={16} /> Video Only
                    </Button>
                    <Button
                      onClick={() => setSingleStoryViewer(prev => ({ ...prev, viewerMode: 'both' }))}
                      variant={singleStoryViewer.viewerMode === 'both' ? 'primary' : 'ghost'}
                      style={{
                        background: singleStoryViewer.viewerMode === 'both' ? '#db2777' : 'transparent',
                        color: 'white',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '0.5rem',
                        padding: '0.5rem 1rem'
                      }}
                    >
                      <BookOpen size={16} /> <Video size={16} /> Both
                    </Button>
                  </>
                )}
                <Button
                  onClick={closeSingleStoryViewer}
                  variant="ghost"
                  style={{ color: 'white', fontSize: '1.5rem', padding: '0.5rem 1rem' }}
                >
                  <X size={24} />
                </Button>
              </div>
            </div>

            {/* Content Area */}
            <div style={{ 
              flex: 1, 
              display: 'flex', 
              gap: '1rem', 
              padding: '1rem',
              overflow: 'hidden'
            }}>

            {singleStoryViewer.recording.is_ai && (
              <>
                {/* Book Section for AI */}
                <div style={{ 
                  flex: 1,
                  background: '#fff',
                  borderRadius: '0.5rem',
                  overflow: 'hidden',
                  position: 'relative'
                }}>
                  {console.log('AI Recording book data:', singleStoryViewer.recording.book)}
                  {console.log('AI Recording pdf_url:', singleStoryViewer.recording.book?.pdf_url)}
                  {(singleStoryViewer.recording.book?.pdf_url || singleStoryViewer.recording.pdf_url) ? (
                    <iframe
                      src={(singleStoryViewer.recording.book?.pdf_url || singleStoryViewer.recording.pdf_url).trim()}
                      style={{
                        width: '100%',
                        height: '100%',
                        border: 'none'
                      }}
                      title={singleStoryViewer.recording.book_title}
                    />
                  ) : (
                    <div style={{ 
                      display: 'flex', 
                      alignItems: 'center', 
                      justifyContent: 'center', 
                      height: '100%',
                      fontSize: '1.25rem',
                      color: '#6b7280'
                    }}>
                      No book PDF available (book: {JSON.stringify(singleStoryViewer.recording.book)})
                    </div>
                  )}
                </div>

                {/* Audio Player Overlay */}
                <div style={{
                  position: 'absolute',
                  bottom: '2rem',
                  left: '50%',
                  transform: 'translateX(-50%)',
                  background: 'linear-gradient(135deg, #8b5cf6, #6d28d9)',
                  padding: '1.5rem 2rem',
                  borderRadius: '1rem',
                  boxShadow: '0 8px 32px rgba(139, 92, 246, 0.4)',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '1rem',
                  minWidth: '400px',
                  zIndex: 10
                }}>
                  <div style={{
                    width: '48px',
                    height: '48px',
                    background: 'rgba(255, 255, 255, 0.2)',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '1.5rem'
                  }}>
                    🤖
                  </div>
                  <div style={{ flex: 1 }}>
                    <p style={{ color: 'white', fontWeight: '600', fontSize: '1rem', marginBottom: '0.25rem' }}>
                      AI Audio Playing
                    </p>
                    <p style={{ color: '#e5e7eb', fontSize: '0.875rem' }}>
                      {singleStoryViewer.recording.voice_name}
                    </p>
                  </div>
                  <audio
                    ref={audioRefSingle}
                    src={singleStoryViewer.recording.audio_url}
                    controls
                    autoPlay
                    onEnded={handleSingleStoryEnded}
                    style={{
                      maxWidth: '300px'
                    }}
                  />
                </div>
              </>
            )}
              {/* Regular Recording Section (Video and/or Audio) */}
              {!singleStoryViewer.recording.is_ai && (
                <>
                  {/* Video Section - only show if video exists and mode is video or both */}
                  {singleStoryViewer.recording.video_url && (singleStoryViewer.viewerMode === 'video' || singleStoryViewer.viewerMode === 'both') && (
                    <div style={{ 
                      flex: singleStoryViewer.viewerMode === 'both' ? 1 : '1',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      background: '#000'
                    }}>
                      <video
                        ref={videoRefSingle}
                        src={singleStoryViewer.recording.video_url}
                        controls
                        autoPlay
                        onEnded={handleSingleStoryEnded}
                        style={{
                          maxWidth: '100%',
                          maxHeight: '100%',
                          width: '100%',
                          height: '100%'
                        }}
                      />
                    </div>
                  )}

                  {/* Book Section - show if mode is book or both, OR if it's audio-only */}
                  {(singleStoryViewer.viewerMode === 'book' || singleStoryViewer.viewerMode === 'both' || !singleStoryViewer.recording.video_url) && (
                    <div style={{ 
                      flex: singleStoryViewer.viewerMode === 'both' ? 1 : '1',
                      background: '#fff',
                      borderRadius: '0.5rem',
                      overflow: 'hidden'
                    }}>
                      {singleStoryViewer.recording.book?.pdf_url ? (
                        <iframe
                          src={singleStoryViewer.recording.book.pdf_url.trim()}
                          style={{
                            width: '100%',
                            height: '100%',
                            border: 'none'
                          }}
                          title={singleStoryViewer.recording.book_title}
                        />
                      ) : (
                        <div style={{ 
                          display: 'flex', 
                          alignItems: 'center', 
                          justifyContent: 'center', 
                          height: '100%',
                          fontSize: '1.25rem',
                          color: '#6b7280'
                        }}>
                          No book PDF available
                        </div>
                      )}
                    </div>
                  )}

                  {/* Audio Player Overlay for audio-only grandparent recordings */}
                  {!singleStoryViewer.recording.video_url && singleStoryViewer.recording.audio_url && (
                    <div style={{
                      position: 'absolute',
                      bottom: '2rem',
                      left: '50%',
                      transform: 'translateX(-50%)',
                      background: 'linear-gradient(135deg, #db2777, #be185d)',
                      padding: '1.5rem 2rem',
                      borderRadius: '1rem',
                      boxShadow: '0 8px 32px rgba(219, 39, 119, 0.4)',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '1rem',
                      minWidth: '400px'
                    }}>
                      <div style={{
                        width: '48px',
                        height: '48px',
                        background: 'rgba(255, 255, 255, 0.2)',
                        borderRadius: '50%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '1.5rem'
                      }}>
                        🎙️
                      </div>
                      <div style={{ flex: 1 }}>
                        <p style={{ color: 'white', fontWeight: '600', fontSize: '1rem', marginBottom: '0.25rem' }}>
                          Audio Recording
                        </p>
                        <p style={{ color: '#e5e7eb', fontSize: '0.875rem' }}>
                          {singleStoryViewer.recording.reader_name}
                        </p>
                      </div>
                      <audio
                        ref={audioRefSingle}
                        src={singleStoryViewer.recording.audio_url}
                        controls
                        autoPlay
                        onEnded={handleSingleStoryEnded}
                        style={{
                          maxWidth: '300px'
                        }}
                      />
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
        )}
        <PersonalBookModal
          isOpen={isPersonalBookModalOpen}
          onClose={() => setIsPersonalBookModalOpen(false)}
          onProceedToRecord={handlePersonalBookRecord}
        />
        <LiveCallModal
          isOpen={showLiveCallModal}
          onClose={() => setShowLiveCallModal(false)}
          familyId={familyData?.id}
          currentUser={user}
          socket={socket}  // ⭐ ADD THIS
          onCallInitiated={(data) => {
            console.log('✅ Call accepted, joining:', data);
            setActiveVideoCall({
              roomId: data.roomId,
              participants: data.participants
            });
            setShowLiveCallModal(false);
          }}
        />

        {/* Incoming Call Notification */}
        {incomingCall && (
          <IncomingCallNotification
            caller={incomingCall.caller}
            roomId={incomingCall.roomId}
            onAccept={handleAcceptCall}
            onDecline={handleDeclineCall}
          />
        )}

        {/* Active Video Call Room */}
        {activeVideoCall && (
          <VideoCallRoom
            roomId={activeVideoCall.roomId}
            currentUser={user}
            onLeave={handleLeaveCall}
            participants={activeVideoCall.participants}
          />
        )}
    </div>
  );
};